export default __webpack_public_path__ + "static/media/boordKlein.c404414e.jpg";